import { useState } from 'react'
import type { ResultFilters } from '@/store/dashboard'
import { buildResultsQuery } from '@/store/dashboard'
import { API_BASE } from '@/lib/api'

interface Props {
  brandId: string
  brandName: string
  filters: ResultFilters
}

export function CsvExportButton({ brandId, brandName, filters }: Props) {
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setLoading(true)
    try {
      const qs = buildResultsQuery(filters)
      const res = await fetch(`${API_BASE}/api/results/${brandId}/export.csv?${qs}`, {
        credentials: 'include',
      })
      if (!res.ok) {
        console.error('CSV export failed:', res.status)
        return
      }
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      const safeName = brandName.replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase()
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, '')
      a.href = url
      a.download = `ekorank-${safeName}-${today}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    } finally {
      setLoading(false)
    }
  }

  return (
    <button
      onClick={() => void handleClick()}
      disabled={loading}
      className="px-3 py-1.5 rounded border border-outline-variant/20 text-on-surface-variant hover:border-outline-variant/40 hover:text-white disabled:opacity-40 transition-colors text-xs font-mono whitespace-nowrap"
    >
      {loading ? 'Exporting…' : '↓ CSV'}
    </button>
  )
}
